export const getTourSteps = (isMobile) => [
  // Step 1: Upload Tab
  {
    target: '[data-tour="nav-upload"]',
    content: 'Upload your course syllabi here to get started. Ocean will automatically extract your schedule and deadlines.',
    title: 'Upload Syllabi',
    placement: isMobile ? 'left' : 'right',
    disableBeacon: true,
    route: '/upload',
    spotlightClicks: false,
    spotlightPadding: isMobile ? 0 : 2
  },

  // Step 2: Calendar Tab
  {
    target: '[data-tour="nav-calendar"]',
    content: 'View your complete schedule, assignments, and deadlines all in one place.',
    title: 'Your Calendar',
    placement: isMobile ? 'left' : 'right',
    disableBeacon: true,
    route: '/upload', // Stay on upload page
    spotlightClicks: false,
    spotlightPadding: isMobile ? 0 : 2
  },

  // Step 3: Courses Tab
  {
    target: '[data-tour="nav-courses"]',
    content: 'Manage your courses, track assignments, and monitor your progress.',
    title: 'Manage Courses',
    placement: isMobile ? 'left' : 'right',
    disableBeacon: true,
    route: '/upload', // Stay on upload page
    spotlightClicks: false,
    spotlightPadding: isMobile ? 0 : 2
  },

  // Step 4: Console Tab
  {
    target: '[data-tour="nav-console"]',
    content: 'Get AI-powered study recommendations based on your schedule and workload.',
    title: 'AI Study Planner',
    placement: isMobile ? 'left' : 'right',
    disableBeacon: true,
    route: '/upload', // Stay on upload page
    spotlightClicks: false,
    spotlightPadding: isMobile ? 0 : 2
  }
];
